var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, ceilToNearest } from '@shapeable/utils';
import { CircleTrailBar, CircleTrailBarHeights } from './circle-trail-bar';
import { ChartGrid } from './chart-grid';
import { useInViewEffect } from '../hooks/use-in-view-effect';
import { LineGridDefaultProps } from './line-grid';
import { filter, first, maxBy, pick } from 'lodash';
import { CircleTrailBarChartLabel } from './circle-trail-bar-chart-label';
import { CircleTrailBarChartGroupLabel } from './circle-trail-bar-chart-group-label';
var cls = classNames('circle-bar-trail-chart');
export var CircleTrailBarChartHeightSizeMultiplers = {
  default: 5,
  medium: 4,
  small: 5,
  large: 2
};
export var CircleTrailBarChartDefaultProps = __assign(__assign({
  backgroundColor: '#ebebeb',
  items: []
}, pick(LineGridDefaultProps, ['majorDivisions', 'minorDivisions', 'majorOpacity', 'minorOpacity', 'middleMinorOpactity', 'majorWidth', 'minorWidth'])), {
  showFirstGroupAsHeader: true,
  showDividers: true,
  groupHeight: 25,
  showAxis: true,
  showMarks: true,
  showTicks: true,
  lineColor: 'light',
  majorWidth: 1,
  showValues: true,
  showCountupValues: true,
  extraDivisions: 0,
  heightSizeMultipliers: CircleTrailBarChartHeightSizeMultiplers
});
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 0.8em;\n    padding: ", " ", " ", " ", ";\n    ", "\n  "], ["\n    font-size: 0.8em;\n    padding: ", " ", " ", " ", ";\n    ", "\n  "])), theme.UNIT(2), theme.UNIT(5), theme.UNIT(2), theme.UNIT(4), function (_a) {
    var _bg = _a._bg;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR(_bg));
  }),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 0.9em;\n    padding: ", " ", ";\n  "], ["\n    font-size: 0.9em;\n    padding: ", " ", ";\n  "])), theme.UNIT(3), theme.UNIT(6)),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    padding: ", " ", ";\n  "], ["\n    font-size: 1em;\n    padding: ", " ", ";\n  "])), theme.UNIT(4), theme.UNIT(8))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: baseline;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    align-items: baseline;\n    margin-bottom: ", ";\n  "])), theme.UNIT(2))
});
var HeaderGroupLabelContainerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 40%;\n  "], ["\n    width: 40%;\n  "]))),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 30%;\n  "], ["\n    width: 30%;\n  "])))
});
var GridTitleStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    width: 60%;\n    text-align: center;\n    font-weight: 600;\n    font-size: 1em;\n    color: ", ";\n    margin: 0;\n  "], ["\n    width: 60%;\n    text-align: center;\n    font-weight: 600;\n    font-size: 1em;\n    color: ", ";\n    margin: 0;\n  "])), theme.COLOR('light')),
  tablet: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: 1.25em;\n    width: 70%;\n  "], ["\n    font-size: 1.25em;\n    width: 70%;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    width: 100%;\n  "])))
});
var LabelsStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    position: relative;\n    width: 40%;\n    ", "\n  "], ["\n    position: relative;\n    width: 40%;\n    ", "\n  "])), function (_a) {
    var showAxis = _a.showAxis;
    return showAxis && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n    "], ["\n      border-bottom: 1px solid ", ";\n    "])), theme.COLOR('light'));
  }),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 30%;\n  "], ["\n    width: 30%;\n  "])))
});
var GroupLabelContainerStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    left: 0;\n    position: absolute;\n  "], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    left: 0;\n    position: absolute;\n  "])))
});
var LabelContainerStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    left: 0;\n    position: absolute;\n    ", "\n  "], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    left: 0;\n    position: absolute;\n    ", "\n  "])), function (_a) {
    var lineWidth = _a.lineWidth,
      _color = _a._color,
      showDividers = _a.showDividers;
    return showDividers && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      border-top: ", "px solid ", ";\n    "], ["\n      border-top: ", "px solid ", ";\n    "])), lineWidth, theme.COLOR(_color));
  })
});
var ValuesStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    position: relative;\n    width: 60%;\n  "], ["\n    position: relative;\n    width: 60%;\n  "]))),
  tablet: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    width: 70%;\n  "], ["\n    width: 70%;\n  "])))
});
var ChartGridStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BarStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    margin-top: -1px;\n  "], ["\n    margin-top: -1px;\n  "])))
});
var BarContainerStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    left: 0;\n    position: absolute;\n    z-index: 20;\n\n    ", "\n  "], ["\n    width: 100%;\n    display: flex;\n    align-items: center;\n    left: 0;\n    position: absolute;\n    z-index: 20;\n\n    ", "\n  "])), function (_a) {
    var lineWidth = _a.lineWidth,
      _color = _a._color,
      showDividers = _a.showDividers;
    return showDividers && css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n      border-top: ", "px solid ", ";\n    "], ["\n      border-top: ", "px solid ", ";\n    "])), lineWidth, theme.COLOR(_color));
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    line-height: 1.1em;\n  "], ["\n    line-height: 1.1em;\n  "])))
});
var GroupLabelStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled.div.attrs(cls.attr('header'))(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  HeaderGroupLabelContainer: styled.div.attrs(cls.attr('header-group-label-container'))(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), HeaderGroupLabelContainerStyles),
  GridTitle: styled.h3.attrs(cls.attr('grid-title'))(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), GridTitleStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Labels: styled.div.attrs(cls.attr('labels'))(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), LabelsStyles),
  GroupLabelContainer: styled.div.attrs(cls.attr('group-label-container'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), GroupLabelContainerStyles),
  GroupLabel: styled(CircleTrailBarChartGroupLabel)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), GroupLabelStyles),
  LabelContainer: styled.div.attrs(cls.attr('label-container'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), LabelContainerStyles),
  Label: styled(CircleTrailBarChartLabel)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Values: styled.div.attrs(cls.attr('values'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ValuesStyles),
  BarContainer: styled.div.attrs(cls.attr('bar-container'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), BarContainerStyles),
  Bar: styled(CircleTrailBar)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), BarStyles),
  ChartGrid: styled(ChartGrid)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ChartGridStyles)
};
export var CircleTrailBarChart = function (props) {
  var className = props.className,
    backgroundColor = props.backgroundColor,
    majorWidth = props.majorWidth,
    minorWidth = props.minorWidth,
    majorDivisions = props.majorDivisions,
    minorDivisions = props.minorDivisions,
    majorOpacity = props.majorOpacity,
    minorOpacity = props.minorOpacity,
    items = props.items,
    heightSizeMultipliers = props.heightSizeMultipliers,
    lineColor = props.lineColor,
    extraDivisions = props.extraDivisions,
    groupHeight = props.groupHeight,
    gridTitle = props.gridTitle,
    showFirstGroupAsHeader = props.showFirstGroupAsHeader,
    showValues = props.showValues,
    showCountupValues = props.showCountupValues,
    showMarks = props.showMarks,
    showTicks = props.showTicks,
    showDividers = props.showDividers,
    showAxis = props.showAxis;
  var _a = __read(useState(0), 2),
    percentageMultiplier = _a[0],
    setPercentageMultiplier = _a[1];
  var _b = __read(useState(0), 2),
    rotation = _b[0],
    setRotation = _b[1];
  var maxItem = maxBy(items, function (item) {
    return item.value;
  });
  var upperValue = props.upperValue || maxItem && maxItem.value || 100;
  var nearestUnit = maxItem && Math.pow(10, Math.floor(Math.log10(upperValue))) || 100;
  var maxValue = (maxItem && ceilToNearest(upperValue, nearestUnit)) + extraDivisions * nearestUnit || 1000;
  var itemsWithMeta = items.map(function (item) {
    var itemHeight = item.size && CircleTrailBarHeights[item.size] || 50;
    var multiplier = heightSizeMultipliers[item.size] || 3;
    return __assign(__assign({}, item), {
      itemHeight: itemHeight,
      percentage: (percentageMultiplier * 100 * item.value / maxValue).toFixed(2),
      totalHeight: itemHeight * multiplier
    });
  });
  var hasHeader = gridTitle || showFirstGroupAsHeader;
  var ref = useInViewEffect(function () {
    setPercentageMultiplier(1);
    setRotation(360 * 2);
  });
  var Label = props.labelComponent || My.Label;
  var GroupLabel = props.groupLabelComponent || My.GroupLabel;
  var height = itemsWithMeta.reduce(function (acc, item) {
    return acc + item.totalHeight;
  }, 0);
  var gridProps = {
    backgroundColor: backgroundColor,
    minorDivisions: minorDivisions,
    majorDivisions: majorDivisions,
    showMarks: showMarks,
    showAxis: showAxis,
    showTicks: showTicks,
    gridHeight: "".concat(height || 10, "px"),
    majorWidth: majorWidth,
    minorWidth: minorWidth,
    minorColor: lineColor,
    majorColor: lineColor,
    maxValue: maxValue,
    majorOpacity: majorOpacity,
    minorOpacity: minorOpacity
  };
  var ly = 0;
  var y = 0;
  var lastGroupRendered = '';
  var firstGroupNameItem = first(filter(itemsWithMeta, function (item) {
    return !!item.groupName;
  }));
  var firstGroupName = firstGroupNameItem && firstGroupNameItem.groupName;
  return React.createElement(My.Container, {
    ref: ref,
    _bg: backgroundColor,
    className: cls.name(className)
  }, hasHeader && React.createElement(My.Header, null, React.createElement(My.HeaderGroupLabelContainer, null, showFirstGroupAsHeader && firstGroupName && React.createElement(GroupLabel, null, firstGroupName, ":")), gridTitle && React.createElement(My.GridTitle, null, gridTitle)), React.createElement(My.Body, null, React.createElement(My.Labels, {
    showAxis: showAxis,
    style: {
      height: "".concat(height || 10, "px")
    }
  }, itemsWithMeta.map(function (item, index) {
    var groupLabel = '';
    if (lastGroupRendered !== item.groupName) {
      if (lastGroupRendered !== '') {
        groupLabel = "".concat(item.groupName, ":");
      }
      lastGroupRendered = item.groupName;
    }
    var style = {
      height: "".concat(item.totalHeight, "px"),
      top: "".concat(ly, "px")
    };
    var labelStyle = {
      top: "".concat(ly - groupHeight, "px")
    };
    ly += item.totalHeight;
    return React.createElement(React.Fragment, {
      key: "label-".concat(index)
    }, groupLabel && React.createElement(My.GroupLabelContainer, {
      style: labelStyle
    }, React.createElement(GroupLabel, null, groupLabel)), React.createElement(My.LabelContainer, {
      showDividers: showDividers,
      _color: lineColor,
      lineWidth: majorWidth,
      style: style
    }, React.createElement(Label, {
      onClick: item.onLabelClick,
      item: item
    })));
  })), React.createElement(My.Values, null, React.createElement(My.ChartGrid, __assign({}, gridProps)), itemsWithMeta.map(function (item, index) {
    var style = {
      height: "".concat(item.totalHeight, "px"),
      top: "".concat(y, "px")
    };
    y += item.totalHeight;
    return React.createElement(React.Fragment, {
      key: "value-".concat(index)
    }, React.createElement(My.BarContainer, {
      showDividers: showDividers,
      _color: lineColor,
      lineWidth: majorWidth,
      style: style
    }, React.createElement(My.Bar, {
      rotation: rotation,
      onClick: item.onCircleClick,
      showCountUp: showCountupValues,
      showValue: showValues,
      value: item.value,
      size: item.size,
      width: "".concat(item.percentage, "%"),
      color: item.color
    })));
  }))));
};
CircleTrailBarChart.defaultProps = CircleTrailBarChartDefaultProps;
CircleTrailBarChart.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38;